module.exports = __webpack_public_path__ + "static/healthnx-mission-one-1c35c2dae103c67529a5bac73aaf41fd.jpg";